(() => {
  const form = document.getElementById('cs-porto-form');
  if (!form) return;

  const status = document.getElementById('cs-porto-status');
  const button = document.getElementById('cs-porto-submit');
  const confirmation = document.getElementById('cs-porto-confirmation');
  const academyWrap = document.getElementById('cs-porto-academy-wrap');
  const academyName = form.elements.nombre_academia;
  const academyOptions = form.querySelectorAll('input[name="academia_natacion"]');

  function showStatus(message, state) {
    status.textContent = message;
    status.dataset.state = state || '';
    status.hidden = !message;
  }

  function updateAcademy() {
    const selected = form.querySelector('input[name="academia_natacion"]:checked');
    const hasAcademy = selected && selected.value === 'Sí';
    academyWrap.hidden = !hasAcademy;
    academyName.required = Boolean(hasAcademy);
    if (!hasAcademy) academyName.value = '';
  }

  academyOptions.forEach((option) => option.addEventListener('change', updateAcademy));
  updateAcademy();

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (button.disabled) return;

    updateAcademy();
    if (!form.reportValidity()) return;

    if (form.dataset.backendReady !== 'true') {
      showStatus('La convocatoria todavía no recibe postulaciones. Vuelve a intentarlo cuando esté habilitada.', 'error');
      return;
    }

    const endpoint = form.dataset.endpoint;
    if (!endpoint) {
      showStatus('El formulario no está disponible en este momento. Inténtalo más tarde.', 'error');
      return;
    }

    const value = (name) => form.elements[name].value.trim();
    const payload = {
      form_id: 'porto_modelos',
      timestamp: new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }),
      nombre_completo: value('nombre_completo'),
      correo_electronico: value('correo_electronico'),
      dni: value('dni'),
      numero_contacto: value('numero_contacto'),
      red_social_url: value('red_social_url'),
      experiencia_camara: value('experiencia_camara'),
      comodidad_camara: value('comodidad_camara'),
      experiencia_nadando: value('experiencia_nadando'),
      contenido_redes_previo: value('contenido_redes_previo'),
      academia_natacion: value('academia_natacion'),
      nombre_academia: value('nombre_academia'),
      tiempo_natacion: value('tiempo_natacion'),
      autoriza_tratamiento_datos: form.elements.autoriza_tratamiento_datos.checked ? 'Sí' : 'No'
    };

    button.disabled = true;
    showStatus('Enviando tu postulación…');

    try {
      // Igual que Matadorcita: Apps Script recibe JSON mediante un POST no-cors.
      // La respuesta es opaca; el navegador solo puede detectar fallos de red.
      await fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      form.hidden = true;
      confirmation.hidden = false;
      confirmation.focus();
    } catch (error) {
      showStatus('No se pudo enviar tu postulación. Revisa tu conexión e inténtalo nuevamente.', 'error');
      button.disabled = false;
    }
  });
})();
